<template>
  <div class="hotel-skeleton" tag="section">
    <ContentLoader
      class="d-none d-md-block"
      height="3000"
      width="825"
      :speed="2"
      primaryColor="#f3f3f3"
      secondaryColor="#dedede"
    >
      <!-- image hotel -->
      <rect x="0" y="0" rx="4" ry="4" width="825" height="470" />
      <!-- title -->
      <rect x="0" y="550" rx="4" ry="4" width="420" height="80" />
      <!-- lanes -->
      <rect x="0" y="700" rx="4" ry="4" width="520" height="22" />
      <rect x="0" y="740" rx="4" ry="4" width="520" height="22" />
      <rect x="0" y="780" rx="4" ry="4" width="520" height="22" />
      <rect x="0" y="820" rx="4" ry="4" width="290" height="22" />
      <!-- Map -->
      <rect x="25" y="880" rx="4" ry="4" width="775" height="775" />
      <!-- Rewards -->
      <rect x="0" y="1750" rx="4" ry="4" width="825" height="470" />
      <!-- Tripadvisor -->
      <rect x="0" y="2350" rx="4" ry="4" width="825" height="825" />
    </ContentLoader>

    <ContentLoader
      class="d-md-none"
      height="670"
      width="825"
      :speed="2"
      primaryColor="#f3f3f3"
      secondaryColor="#dedede"
    >
      <!-- image hotel -->
      <rect x="0" y="0" rx="4" ry="4" width="825" height="400" />
      <!-- title -->
      <rect x="50" y="420" rx="4" ry="4" width="220" height="25" />
      <!-- lanes -->
      <rect x="50" y="460" rx="4" ry="4" width="440" height="25" />
      <rect x="50" y="500" rx="4" ry="4" width="460" height="14" />
      <rect x="50" y="530" rx="4" ry="4" width="480" height="14" />
      <!-- Rewards -->
      <rect x="0" y="570" rx="4" ry="4" width="825" height="100" />
    </ContentLoader>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  components: {
    ContentLoader
  }
}
</script>

<style></style>
